import { Component } from '@angular/core';
import { NodeUtils } from '@core/utils/node.utils';
import { faIdBadge } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from '@portal-shared/app/components/base-components/base.component';
import { GuidString } from '@portal-shared/app/typings/guid-string.type';
import { BudgetGroupBaseComponent } from '@shared/components/budget-group-base/budget-group-base.component';
import { CellDropZoneComponent } from '@shared/components/cell-drop-zone/cell-drop-zone.component';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { ClassGroupRow } from '../../rows/groups/class-group.row';
import { PlanningGroupRow } from '../../rows/groups/planning-group.row';

@Component({
  selector: 'al-class-group-cell-renderer',
  templateUrl: 'class-group-cell-renderer.component.html',
  styleUrl: 'class-group-cell-renderer.component.scss',
  imports: [BudgetGroupBaseComponent, CellDropZoneComponent]
})
export class ClassGroupCellRendererComponent extends BaseComponent implements ICellRendererAngularComp {
  public readonly translationKey = 'common.class';
  public readonly faIdBadge = faIdBadge;

  public classRow?: ClassGroupRow;
  public node!: IRowNode<ClassGroupRow>;
  public refreshSubject = new Subject<void>();

  public get isDroppable() {
    return NodeUtils.isCellDroppable(this.node);
  }
  public constructor() {
    super();
  }

  public agInit(params: ICellRendererParams<ClassGroupRow, GuidString>): void {
    this.node = params.node;
    this.classRow = params.data;

    const parent = this.node.parent as IRowNode<PlanningGroupRow>;
    if (parent.data?.expandAll) {
      if (this.node.data) {
        this.node.data.expandAll = true;
      }
      this.expand(true);
    }
  }

  public refresh(_: ICellRendererParams<ClassGroupRow, GuidString>) {
    this.refreshSubject.next();
    return true;
  }

  public expand(expand = true) {
    this.node.setExpanded(expand);
  }
}
